/* Kailar Neubau D · Newsletter-Fenster (#kd-pop, snippets/d-news-popup.liquid).
   Öffnet sich einmal nach 15 s oder sobald die halbe Seite gelesen ist, über KD.open (Fokus, Escape, Scrim aus d-kd.js).
   Nie, wenn schon angemeldet (kd-news), Lasche zu/eingelöst (kd-lasche-off) oder in den letzten 14 Tagen gezeigt/geschlossen (kd-news-pop).
   Wartet, solange eine andere Schublade, das Cookie-Banner oder ein Eingabefeld offen ist. Erscheint ohne Bewegung.
   Nach dem Absenden lädt Shopify die Seite mit #kd-pop-form neu: dann zeigt das Fenster Erfolg oder Fehler.
   Mit gesetztem Feld „Good Repeats signup address“ bleibt die Seite stehen, d-kd.js (KD.newsSend) zeigt Erfolg oder Fehler im Fenster. */
(() => {
  const box = document.getElementById('kd-pop');
  if (!box || !window.KD) return;
  const $ = (s, r = document) => r.querySelector(s);
  const T = (window.KD_CFG && window.KD_CFG.t) || {};
  const KEY = 'kd-news-pop';
  const PAUSE = 14 * 864e5;
  const WAIT = 15000;
  const get = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const set = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* privat */ } };
  const html = document.documentElement;

  /* Offen/zu merken; die Klasse hält Scrim und Fenster ohne Überblendung, auch beim Schließen */
  let wasOn = false;
  new MutationObserver(() => {
    const on = box.classList.contains('is-on');
    if (on === wasOn) return;
    wasOn = on;
    if (on) html.classList.add('kd-pop-open');
    else { set(KEY, String(Date.now())); setTimeout(() => { if (!box.classList.contains('is-on')) html.classList.remove('kd-pop-open'); }, 240); }
  }).observe(box, { attributes: true, attributeFilter: ['class'] });
  /* Good Repeats (window.KD.newsEngine, Feld leer = ''): Anmeldung beim Motor statt Shopify-Kundenformular */
  const ENGINE = window.KD.newsEngine || '';
  const show = () => {
    html.classList.add('kd-pop-open'); set(KEY, String(Date.now())); window.KD.open('kd-pop');
    /* Nur auf dem Motor-Weg: ein anonymer Zähler je Öffnen (kein Inhalt, kein Cookie) */
    if (ENGINE && navigator.sendBeacon) navigator.sendBeacon(ENGINE + '/view');
  };

  /* Prüfen vor dem Absenden (gleiche Regeln wie die 5-€-Anmeldung) */
  const form = $('form', box);
  const mail = form && $('input[type="email"]', form);
  if (mail) {
    const field = mail.closest('.kd-field'); const msg = $('.kd-field__msg', field);
    const haken = $('[data-kd-pop-ok]', form); const hField = haken.closest('.kd-field'); const hMsg = $('.kd-field__msg', hField);
    const icon = ($('#kd-icon-warning-circle') || {}).innerHTML || '';
    const warn = (el, text) => { el.innerHTML = icon + `<span>${text}</span>`; };
    form.addEventListener('submit', (e) => {
      const ok = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((mail.value || '').trim());
      field.classList.toggle('is-err', !ok); field.classList.toggle('is-ok', ok);
      if (!ok) { e.preventDefault(); warn(msg, T.newsMailFehlt); mail.focus(); return; }
      /* Einwilligung: Häkchen ist Pflicht und nie vorausgewählt */
      if (!haken.checked) { e.preventDefault(); hField.classList.add('is-err'); warn(hMsg, T.newsHakenFehlt); hMsg.hidden = false; haken.focus(); return; }
      if (ENGINE) { e.preventDefault(); window.KD.newsSend(form, 'Popup'); }
    });
    if (ENGINE) window.KD.newsTrap(form);
    mail.addEventListener('input', () => { if (field.classList.contains('is-err')) { field.classList.remove('is-err'); msg.innerHTML = `<span>${T.newsAbmelden}</span>`; } });
    haken.addEventListener('change', () => { if (haken.checked) { hField.classList.remove('is-err'); hMsg.hidden = true; } });
  }

  /* Zurück vom Absenden über dieses Fenster: Erfolg oder Fehler hier zeigen (d-kd öffnet sonst die 5-€-Schublade) */
  const state = ($('[data-kd-pop-state]', box) || {}).dataset?.kdPopState;
  if (location.hash === '#kd-pop-form' && state) {
    if (state === 'done') set('kd-news', '1');
    show();
    return;
  }
  if (state === 'done' || get('kd-news')) return;
  /* Lasche per X zu (Zeitstempel bis wann) oder Gutschein schon eingelöst ('used'): dann auch kein Fenster */
  const lascheZu = () => { const off = get('kd-lasche-off'); return off === 'used' || Number(off) > Date.now(); };
  if (lascheZu()) return;
  const last = Number(get(KEY));
  if (last && Date.now() - last < PAUSE) return;

  /* Nicht dazwischenfunken: andere Schublade, Cookie-Banner, Tippen, Tab im Hintergrund */
  const banner = () => {
    const b = document.getElementById('shopify-pc__banner');
    return !!(b && b.getClientRects().length && getComputedStyle(b).visibility !== 'hidden' && getComputedStyle(b).display !== 'none');
  };
  const busy = () => {
    const a = document.activeElement;
    return document.hidden || !!$('.kd-sheet.is-on, .kd-lightbox.is-on') || banner() || !!(a && a.matches('input, textarea, select'));
  };
  let done = false; let timer = 0;
  const go = () => {
    if (done) return;
    if (busy()) { clearTimeout(timer); timer = setTimeout(go, 3000); return; }
    done = true; clearTimeout(timer); removeEventListener('scroll', onScroll);
    /* Auch wenn die Lasche erst auf dieser Seite per X zuging (Lea, 19.10.2026) */
    if (Number(get(KEY)) > last || get('kd-news') || lascheZu()) return;
    show();
  };
  const onScroll = () => {
    const h = document.documentElement.scrollHeight - innerHeight;
    if (h > 0 && scrollY >= h * 0.5) go();
  };
  timer = setTimeout(go, WAIT);
  addEventListener('scroll', onScroll, { passive: true });
})();
